module.exports = __webpack_public_path__ + "img/book.ebc3dab5.svg";